import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import * as defaults from "../mock/mock";
import { fetchContent } from "../services/contentService";

// mock.js çıktısını normalize edilmiş bir objeye dönüştür
const DEFAULT_CONTENT = {
  brand: defaults.BRAND,
  nav: defaults.NAV,
  heroSlides: defaults.HERO_SLIDES,
  heroVideo: defaults.HERO_VIDEO,
  featureCards: defaults.FEATURE_CARDS,
  stats: defaults.STATS,
  services: defaults.SERVICES,
  processSteps: defaults.PROCESS_STEPS,
  programs: defaults.PROGRAMS,
  testimonials: defaults.TESTIMONIALS
};

// API'den gelen key'leri tolere et (snake_case / camelCase / UPPER_SNAKE)
function normalize(api) {
  if (!api) return null;
  const pick = (...keys) => keys.map((k) => api[k]).find((v) => v !== undefined);
  return {
    brand: pick("brand", "BRAND") ?? DEFAULT_CONTENT.brand,
    nav: pick("nav", "NAV", "menu") ?? DEFAULT_CONTENT.nav,
    heroSlides: pick("heroSlides", "HERO_SLIDES", "hero_slides") ?? DEFAULT_CONTENT.heroSlides,
    heroVideo: pick("heroVideo", "HERO_VIDEO", "hero_video") ?? DEFAULT_CONTENT.heroVideo,
    featureCards: pick("featureCards", "FEATURE_CARDS", "feature_cards") ?? DEFAULT_CONTENT.featureCards,
    stats: pick("stats", "STATS") ?? DEFAULT_CONTENT.stats,
    services: pick("services", "SERVICES") ?? DEFAULT_CONTENT.services,
    processSteps: pick("processSteps", "PROCESS_STEPS", "process_steps") ?? DEFAULT_CONTENT.processSteps,
    programs: pick("programs", "PROGRAMS") ?? DEFAULT_CONTENT.programs,
    testimonials: pick("testimonials", "TESTIMONIALS") ?? DEFAULT_CONTENT.testimonials
  };
}

const ContentContext = createContext({ ...DEFAULT_CONTENT, loading: false, source: "mock" });

export function ContentProvider({ children }) {
  const [content, setContent] = useState(DEFAULT_CONTENT);
  const [loading, setLoading] = useState(true);
  const [source, setSource] = useState("mock");

  useEffect(() => {
    let alive = true;
    (async () => {
      const api = await fetchContent();
      if (!alive) return;
      const normalized = normalize(api);
      if (normalized) {
        setContent(normalized);
        setSource("api");
      }
      setLoading(false);
    })();
    return () => {
      alive = false;
    };
  }, []);

  const value = useMemo(() => ({ ...content, loading, source }), [content, loading, source]);
  return <ContentContext.Provider value={value}>{children}</ContentContext.Provider>;
}

export function useContent() {
  return useContext(ContentContext);
}
